import React from 'react';
import Attributes from '../../../components/Attributes';
import { PlusCircleIcon } from '@heroicons/react/24/outline';
import Button from '../../../components/Button';

const SERVICE_MODULE_ID = process.env.REACT_APP_MODULE_ID_SERVICE;
const EVENT_MODULE_ID = process.env.REACT_APP_MODULE_ID_EVENT;

const GeneralStepTask = ({
	moduleFieldsBreakdown,
	skipModuleKeys,
	updatedForm,
	setUpdateForm,
	form,
}) => {
	return (
		<>
			{moduleFieldsBreakdown?.general
				?.filter((field) => skipModuleKeys.indexOf(field.key) === -1)
				?.map((field) => (
					<>
						<Attributes
							field={{
								...field,
								disabled:
									field?.key === 'occurrences' && !updatedForm?.serviceStart,
							}}
							onChange={(index, value, fullValue) => {
								if (value || fullValue) {
									let updatedValue = form[index]?.value;

									if (fullValue) {
										updatedValue = fullValue;
									} else {
										if (updatedValue && Array.isArray(value)) {
											updatedValue = [
												...(Array.isArray(updatedValue)
													? updatedValue
													: [updatedValue]),
												...value,
											];
										} else {
											updatedValue = value;
										}
									}

									setUpdateForm({
										...updatedForm,
										[index]: {
											value: updatedValue,
											fieldId: field.id,
										},
									});
								} else {
									let updated = { ...updatedForm };
									updated[index] = {
										...updated[index],
										value: null,
									};

									setUpdateForm(updated);
								}
							}}
							form={{ ...form, ...updatedForm }}
							updatedForm={updatedForm}
							setForm={setUpdateForm}
							moduleId={SERVICE_MODULE_ID}
						/>
					</>
				))}
		</>
	);
};

export default GeneralStepTask;
